import { render, staticRenderFns } from "./couponPropertyPoolDetailList.vue?vue&type=template&id=aa56f42e&scoped=true"
import script from "./couponPropertyPoolDetailList.vue?vue&type=script&lang=js"
export * from "./couponPropertyPoolDetailList.vue?vue&type=script&lang=js"
import style0 from "./couponPropertyPoolDetailList.vue?vue&type=style&index=0&id=aa56f42e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa56f42e",
  null
  
)

export default component.exports